import { Box } from '@mui/material';
import React, { PropsWithChildren } from 'react';

export default function ProductsFilterContainer({ children }: PropsWithChildren) {
    return (
        <Box sx={{ display: [null, null, 'grid'], gridTemplateColumns: '1fr 3fr' }}>
            {children}
        </Box>
    );
}
